<template>
  <el-container class="table">
    <el-table :data="list" v-loading="loading" :show-header="false" class="table">
      <el-table-column align="left">
        <template v-slot="scope">
          <p class="big">{{scope.row.type_desc}}</p>
          <p class="gray">{{getTime(scope.row.create_time)}}</p>
        </template>
      </el-table-column>
      <el-table-column align="right">
        <template v-slot="scope">
          <p class="pink big">{{scope.row.change > 0 ? '+' : '-'}}￥{{Math.abs(scope.row.change / 100)}}</p>
          <p class="gray">余额&emsp;{{scope.row.balance / 100}}</p>
        </template>
      </el-table-column>
    </el-table>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, next, jumper"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'

export default {
  name: 'ClientDetail',
  mixins: [ pageMixin ],
  props: {
    clientId: String
  },
  data () {
    return {
      clientDetailUrl: this.getDomain() + 'bmclient/get_account_info', // 用户详情
      list: []
    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        client_id: this.clientId,
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.list = res.data.content.data
        this.totalCount = res.data.content.total_count
        this.loading = false
      }
      this.__axios(this.clientDetailUrl, params, handle)
    },
    getTime (time) {
      const d = new Date(time * 1000)
      const now = new Date()
      let right
      if (d.getFullYear() === now.getFullYear()) {
        if (d.getMonth() === now.getMonth() && d.getDate() === now.getDate()) {
          right = '今天'
        } else if (d.getMonth() === now.getMonth() && d.getDate() === now.getDate() - 1) {
          right = '昨天'
        } else {
          right = (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) +
            '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate())
        }
        return right + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' +
          (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())
      } else {
        return this.timeTransform(time).slice(0, -3)
      }
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped>
  p {
    margin: 0 20px;
  }

  .pink {
    color: hotpink;
  }

  .gray {
    color: rgb(153, 153, 153);
  }

  .big {
    font-size: 16px;
    font-weight: 600;
  }

  .table {
    height: 400px;
    overflow-y: auto;
  }
</style>
